module.exports = __webpack_public_path__ + "img/manager.cf345634.png";